module.exports = __webpack_public_path__ + "c8d87253d2b6de72f56d895c8e8e48f1.png";